import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CreatemodalPage } from './createmodal';

@NgModule({
  declarations: [
    CreatemodalPage,
  ],
  imports: [
    IonicPageModule.forChild(CreatemodalPage),
  ],
})
export class CreatemodalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/createmodal/createmodal.module.ts